module.exports = __webpack_public_path__ + "static/media/Street Skater.ddcd172c.jpg";